export default import.meta.ROLLUP_FILE_URL_K0d7Xv_kmrg9pjrMnixeoA;